import React from "react";
import { object, array, string } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";
import { Link } from "@quintype/components";

import QuintLensIcon from "../../atoms/icons/quint-lens";
import DoubleRightIcon from "../../atoms/icons/double-angle-right";
import CustomStoryCard1 from "../../molecules/custom-story-card1";
import CustomStoryCard5 from "../../molecules/custom-story-card5";

import { getCollectionSlug } from "../../utils/utils";

import "./quintLens.m.css";

const QuintLens = ({ collection, sections, pageType, publisherName }) => {
  if (!(collection && collection.items)) {
    return null;
  }

  const storiesCount = global.width < 1024 ? 3 : 4;

  const stories = collection.items
    .filter((item) => item.type === "story")
    .slice(0, storiesCount)
    .map((item) => item.story);

  if (!stories.length) {
    return null;
  }

  const getSlug = () => {
    if (pageType === "home-page") {
      return "/photos";
    }

    return getCollectionSlug(collection, sections);
  };

  const [firstStory, ...remainingStories] = stories;

  return (
    <div styleName="wrapper" className="container" id={collection.slug}>
      <div styleName="headline">
        <Link styleName="icon-wrapper" href={getSlug()}>
          <QuintLensIcon />
          <div styleName="collection-name">{publisherName === "quint-hindi" ? collection.name : "Quint Lens"}</div>
        </Link>
        {pageType === "home-page" && (
          <Link href={getSlug()}>
            <DoubleRightIcon />
          </Link>
        )}
      </div>
      <div styleName="content">
        <CustomStoryCard1 story={firstStory} headerType={15} showSummary={false} />
        <div styleName="stories">
          {remainingStories.map((story, index) => (
            <CustomStoryCard5 key={index} story={story} />
          ))}
        </div>
      </div>
    </div>
  );
};

QuintLens.propTypes = {
  collection: object.isRequired,
  sections: array,
  pageType: string,
  publisherName: string,
};

const mapStateToProps = (state) => ({
  sections: get(state, ["qt", "config", "sections"], []),
  pageType: get(state, ["qt", "pageType"], null),
  publisherName: get(state, ["qt", "config", "publisher-attributes", "name"], null),
});

export default connect(mapStateToProps, null)(QuintLens);
